import { useEventLogQuery } from '../../event-state/use-event-log-query';
import { EntityLog } from '../../../panels/entity-panels/entity-log/entity-log';

export function EventLogTabContent({ eventId }: { eventId?: number }) {
    const { data, isInitialLoading } = useEventLogQuery({ eventId });

    return <EntityLog isLoading={isInitialLoading} actions={data} />;
}
